import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Card, Message, List, Header } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { check } from "../../actions/auth";
import PreSignupForm from "../forms/PreSignupForm";
import GuidePage from "./GuidePage";

class PreSignupPage extends Component {
  state = {
    registered: false,
  };
  submit = (data) =>
    this.props.check(data).then((resp) => {
      if (resp.user.isRegistered) {
        this.setState({
          registered: true,
        });
        setTimeout(() => {
          this.setState({
            registered: false,
          });
          this.props.history.push("/");
        }, 1500);
      } else {
        this.props.history.push("/signup");
      }
    });

  render() {
    return (
      <Grid>
        <Grid.Column mobile={16} tablet={16} computer={5}></Grid.Column>
        <Grid.Column
          className="logginSeparation"
          mobile={16}
          tablet={16}
          computer={6}
        >
          {this.state.registered ? (
            <Message color="yellow">
              <Header size="medium">Identificación ya registrada</Header>
            </Message>
          ) : null}
          <Card fluid={true}>
            <Message attached>
              <Header size="medium">Pre-registro</Header>
            </Message>
            <Card.Content>
              <PreSignupForm submit={this.submit} />
            </Card.Content>
            <Message attached="bottom" warning>
              <List horizontal>
                <List.Item>
                  <Link to="/forgot_password">Restablecer contraseña</Link>
                </List.Item>
                <List.Item>
                  <Link to="/">Iniciar sesión</Link>
                </List.Item>
              </List>
            </Message>
          </Card>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={5}>
          <GuidePage />
        </Grid.Column>
      </Grid>
    );
  }
}

export default connect(null, { check })(PreSignupPage);
